import { render, staticRenderFns } from "./exam-image-answer-picker.vue?vue&type=template&id=681319f7&scoped=true"
import script from "./exam-image-answer-picker.vue?vue&type=script&lang=js"
export * from "./exam-image-answer-picker.vue?vue&type=script&lang=js"
import style0 from "./exam-image-answer-picker.vue?vue&type=style&index=0&id=681319f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681319f7",
  null
  
)

export default component.exports